import React from "react";
import { useLocation } from "react-router-dom";
import { WHATSAPP_CHATBOT_URL } from "../../../constants/whatsapp";
import "./WhatsAppChatbotButton.css";

function WhatsAppChatbotButton() {
  const location = useLocation();

  if (location.pathname.replace(/\/$/, "") === "/quick-brand-leads") {
    return null;
  }

  return (
    <a
      className="whatsapp-chatbot-button"
      href={WHATSAPP_CHATBOT_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Open Brew Your Brand chatbot"
      title="Open Brew Your Brand chatbot"
    >
      <span className="whatsapp-chatbot-button__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" role="img" focusable="false">
          <path
            fill="currentColor"
            d="M6.25 4A4.25 4.25 0 0 0 2 8.25v4.1a4.25 4.25 0 0 0 4.25 4.25h.74v2.3c0 .71.82 1.11 1.37.66l3.62-2.96h5.77A4.25 4.25 0 0 0 22 12.35v-4.1A4.25 4.25 0 0 0 17.75 4H6.25Zm1.38 5.05h8.74a.85.85 0 1 1 0 1.7H7.63a.85.85 0 1 1 0-1.7Zm0 3.35h5.96a.85.85 0 1 1 0 1.7H7.63a.85.85 0 1 1 0-1.7Z"
          />
        </svg>
      </span>
    </a>
  );
}

export default WhatsAppChatbotButton;
